import {
  addNewsArticleCategory,
  deleteNewsArticleCategory,
  getNewsArticleCategories,
  updateNewsArticleCategory,
} from "@/services";
import { useMutation, useQuery } from "@tanstack/react-query";

export const NEWS_ARTICLE_CATEGORIES_QUERY_KEY = ["news-article-categories"] as const;

export function useNewsArticleCategories() {
  return useQuery({
    queryKey: NEWS_ARTICLE_CATEGORIES_QUERY_KEY,
    queryFn: getNewsArticleCategories,
    throwOnError: true,
    staleTime: 0,
    gcTime: 0,
  });
}

export function useAddNewsArticleCategory() {
  return useMutation({
    mutationFn: async ({
      id,
      name,
      description,
    }: {
      id: string;
      name: string;
      description?: string;
    }) => addNewsArticleCategory({ id, name, description }),
  });
}

export function useUpdateNewsArticleCategory() {
  return useMutation({
    mutationFn: async ({
      categoryId,
      name,
      description,
    }: {
      categoryId: string;
      name: string;
      description?: string;
    }) => updateNewsArticleCategory({ categoryId, name, description }),
  });
}

export function useDeleteNewsArticleCategory() {
  return useMutation({
    mutationFn: async ({ categoryId }: { categoryId: string }) =>
      deleteNewsArticleCategory({ categoryId }),
  });
}
